import React from "react";

import { useTranslation } from "utils";

import { Button, Col, Form, Link, Row } from "components";

interface PasswordResetButtonsProps {
  loading: boolean;
}

export const PasswordResetButtons = ({ loading }: PasswordResetButtonsProps) => {
  const { t } = useTranslation("signinup");

  return (
    <>
      <Row>
        <Col className="left">
          <p>
            <Link to="/sign-in" className="link green-text">
              {t("changePassword.buttons.signin")}
            </Link>
          </p>
        </Col>
      </Row>
      <Row className="margin-top-325">
        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
              {t("changePassword.title")}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
